var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3 3 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50185228,26.9615325 C7.11526307,26.9615325 6.80147054,26.6579181 6.80147054,26.2837494 L6.80147054,8.20885783 C6.80147054,7.83468916 7.16513493,7.5310747 7.55172414,7.5310747 C7.93831335,7.5310747 8.37931034,7.83468916 8.37931034,8.20885783 L8.37931034,25.4 L21.6206897,25.4 L21.6206897,8.20885783 C21.6206897,7.83468916 22.0616867,7.4 22.4482759,7.4 C22.8349647,7.4 23.1419851,7.83468916 23.1419851,8.20885783 L23.1419851,26.2837494 C23.1419851,26.6579181 22.8283917,26.9615325 22.4417029,26.9615325 L7.50185228,26.9615325 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3,
    y: 6.72057831,
    width: 24,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60383259,16.2770382 L18.2582364,16.2770382 C18.7000642,16.2770382 19.0582364,16.6352104 19.0582364,17.0770382 L19.0582364,17.0770382 C19.0582364,17.518866 18.7000642,17.8770382 18.2582364,17.8770382 L7.60383259,17.8770382 C7.16200479,17.8770382 6.80383259,17.518866 6.80383259,17.0770382 L6.80383259,17.0770382 C6.80383259,16.6352104 7.16200479,16.2770382 7.60383259,16.2770382 Z",
    id: "Rectangle",
    transform: "translate(12.931034, 17.077038) rotate(90.000000) translate(-12.931034, -17.077038) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7417636,16.2770382 L22.3961674,16.2770382 C22.8379952,16.2770382 23.1961674,16.6352104 23.1961674,17.0770382 L23.1961674,17.0770382 C23.1961674,17.518866 22.8379952,17.8770382 22.3961674,17.8770382 L11.7417636,17.8770382 C11.2999358,17.8770382 10.9417636,17.518866 10.9417636,17.0770382 L10.9417636,17.0770382 C10.9417636,16.6352104 11.2999358,16.2770382 11.7417636,16.2770382 Z",
    id: "Rectangle",
    transform: "translate(17.068966, 17.077038) rotate(90.000000) translate(-17.068966, -17.077038) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.629288,7.41806265 L18.629288,4.35560482 L11.3147651,4.35560482 L11.3147651,7.41806265 C11.3147651,7.79232771 11.0010722,8.09594217 10.6143834,8.09594217 C10.2278938,8.09594217 9.91410124,7.79232771 9.91410124,7.41806265 L9.91410124,3.67782169 C9.91410124,3.30365301 10.2278938,3.00003855 10.6143834,3.00003855 L19.3295701,3.00003855 C19.7161593,3.00003855 20.0298523,3.30365301 20.0298523,3.67782169 L20.0298523,7.41806265 C20.0298523,7.79232771 19.7161593,8.09594217 19.3295701,8.09594217 C18.9428813,8.09594217 18.629288,7.79232771 18.629288,7.41806265 Z",
    id: "Fill-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ba211a8d1719957d0f822ea613f836ad.svg";
export { ForwardRef as ReactComponent };